import React, { createContext, useContext, useState } from 'react'
import { SetAuthorizationHeader, removeAuthorizationHeader } from '../config/axiosInterceptor'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(null)
  const [token, setToken] = useState(null)
  const [role, setrole] = useState(null)
  const [username, setUsername] = useState("")
  const [eid, setEid] = useState("")

  const login = async(newToken, role, username, eid) => {
    localStorage.setItem("token", newToken)

    setUsername(username)
    setEid(eid)
    setIsLogin(true)
    setToken(newToken)
    setrole(role)
    await SetAuthorizationHeader(newToken)
  }

  const logout = () => {
    localStorage.removeItem("token")

    setUsername("")
    setEid("")
    setIsLogin(false)
    setToken(null)
    setrole(0)
    removeAuthorizationHeader()
  }

  return (
    <AuthContext.Provider value={{ isLogin, token, role, username, eid, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}